import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid
} from '@material-ui/core';

const VersionWarningDialog = ({ open, onClose }) => {
    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    textAlign: 'center',
                    padding: '20px',
                    margin: '0 auto'
                },
            }}
        >
            <DialogTitle style={{ padding: '20px 0 10px' }}>
                Upgrade Required!
            </DialogTitle>
            <DialogContent>
                This application needs to be upgraded to metadata revision 3 in order to be accessed.
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent="center" alignItems="center">
                    <Button
                        size="large"
                        variant="contained"
                        color="primary"
                        onClick={onClose}
                    >
                        Okay
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};

export default VersionWarningDialog;
